import React, { Component } from 'react';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl, Radio, Checkbox, Button, ButtonToolbar, Alert } from 'react-bootstrap'
import { TableButton } from '../../TableButton';
import { ExceptionsColorForm } from '../ExceptionsColorForm';

export class ExceptionsDataIdentifier extends Component {
    defaultExceptionColors = [
        { bgColor: "103;0;31;1",   textColor: "255;255;255;1", useCustomTextColor: false },
        { bgColor: "178;24;43;1",  textColor: "255;255;255;1", useCustomTextColor: false },
        { bgColor: "214;96;77;1",  textColor: "255;255;255;1", useCustomTextColor: false },
        { bgColor: "244;165;130;1",textColor: "0;0;0;1",       useCustomTextColor: false },
        { bgColor: "253;219;199;1",textColor: "0;0;0;1",       useCustomTextColor: false },
        { bgColor: "209;229;240;1",textColor: "0;0;0;1",       useCustomTextColor: false },
        { bgColor: "146;197;222;1",textColor: "0;0;0;1",       useCustomTextColor: false },
        { bgColor: "67;147;195;1", textColor: "255;255;255;1", useCustomTextColor: false },
        { bgColor: "33;102;172;1", textColor: "255;255;255;1", useCustomTextColor: false },
        { bgColor: "5;48;97;1",    textColor: "255;255;255;1", useCustomTextColor: false }
    ];

    defaultTripNoteExceptionColor = { bgColor: "153;52;4;1",  textColor: "255;255;255;1", useCustomTextColor: false };
    defaultPathNoteExceptionColor = { bgColor: "0;109;44;1",  textColor: "255;255;255;1", useCustomTextColor: false };

    migrateColors(colors) {
        if (!Array.isArray(colors) || colors.length === 0) {
            return this.defaultExceptionColors;
        }
        return colors.map((entry, i) => {
            if (typeof entry === 'string') {
                return {
                    bgColor: entry,
                    textColor: this.defaultExceptionColors[i] ? this.defaultExceptionColors[i].textColor : "255;255;255;1",
                    useCustomTextColor: false
                };
            }
            return entry;
        });
    }

    constructor(props) {
        super(props);

        let exceptionsConfiguration = {
            displayType: "",
            showStopCode: false,
            stopCodePrecendentText: "",
            stopCodeSubsequentText: "",
            exceptionColors: this.defaultExceptionColors,
            tripNoteExceptionColor: this.defaultTripNoteExceptionColor,
            pathNoteExceptionColor: this.defaultPathNoteExceptionColor
        };

        if (null !== this.props.selectedData && undefined !== this.props.selectedData) {
            try {
                exceptionsConfiguration = Object.assign(exceptionsConfiguration, JSON.parse(this.props.selectedData));
            }
            catch(_) { }
        }

        this.state = {
            form: {
                displayType: exceptionsConfiguration.displayType,
                showStopCode: exceptionsConfiguration.showStopCode,
                stopCodePrecendentText: exceptionsConfiguration.stopCodePrecendentText,
                stopCodeSubsequentText: exceptionsConfiguration.stopCodeSubsequentText,
                exceptionColors: this.migrateColors(exceptionsConfiguration.exceptionColors),
                useCustomColorsForNotes: exceptionsConfiguration.useCustomColorsForNotes,
                tripNoteExceptionColor: exceptionsConfiguration.tripNoteExceptionColor || this.defaultTripNoteExceptionColor,
                pathNoteExceptionColor: exceptionsConfiguration.pathNoteExceptionColor || this.defaultPathNoteExceptionColor
            },
            exceptionColorSelected: null,
            exceptionColorSelectedField: null,
            showExceptionColorForm: false,
            exceptionColorFormTitle: "",
            useLineColorBackgorund: false,
            useLineColorText: false,
        };
    }

    onSelectData() {
        const { form } = this.state;

        const exceptionsConfiguration = {
            displayType: form.displayType,
            showStopCode: form.showStopCode,
            stopCodePrecendentText: form.stopCodePrecendentText,
            stopCodeSubsequentText: form.stopCodeSubsequentText,
            exceptionColors: form.exceptionColors,
            tripNoteExceptionColor: form.tripNoteExceptionColor,
            pathNoteExceptionColor: form.pathNoteExceptionColor,
            useCustomColorsForNotes: form.useCustomColorsForNotes
        };

        this.props.onSelectData(JSON.stringify(exceptionsConfiguration), true);
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    onUndoColorSelections() {
        const { form } = this.state;

        form.exceptionColors = this.defaultExceptionColors;
        this.setState({
            form: form
        });
    }

    onSaveExceptionColor(updatedEntry) {
        const { form, exceptionColorSelected, exceptionColorSelectedField } = this.state;

        if (exceptionColorSelectedField === 'tripNoteExceptionColor') {
            form.tripNoteExceptionColor = updatedEntry;
        } else if (exceptionColorSelectedField === 'pathNoteExceptionColor') {
            form.pathNoteExceptionColor = updatedEntry;
        } else {
            form.exceptionColors = form.exceptionColors.map(entry =>
                entry === exceptionColorSelected ? updatedEntry : entry
            );
        }

        this.setState({
            form: form,
            showExceptionColorForm: false,
            exceptionColorSelected: null,
            exceptionColorSelectedField: null
        });
    }

    onChangeRadioValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onEditExceptionColor(entry) {
        this.setState({
            exceptionColorSelected: entry,
            exceptionColorSelectedField: null,
            showExceptionColorForm: true,
            exceptionColorFormTitle: 'Editar'
        });
    }

    onEditNoteExceptionColor(entry, fieldName) {
        this.setState({
            exceptionColorSelected: entry,
            exceptionColorSelectedField: fieldName,
            showExceptionColorForm: true,
            exceptionColorFormTitle: 'Editar'
        });
    }

    onToggleUseCustomColorForNotes() {
        this.setState(prev => ({
            form: {
                ...prev.form,
                useCustomColorsForNotes: !prev.form.useCustomColorsForNotes
            }
        }));
    }

    // -------------------------------

    renderStopTextConfigurationsForm(form) {
        return (
            <div>
                <FormGroup>
                    <ControlLabel className="margin-top-15">Confiração da Apresentação do Nome da Paragem</ControlLabel>
                    <Checkbox checked={form.showStopCode}
                        onChange={() => this.onChangeCheckboxValue("showStopCode")}>
                        Mostrar Código da Paragem
                    </Checkbox>
                </FormGroup>

                {this.renderStopCodePrecedentAndSubsequentTextForm(form)}
            </div>
        );
    }

    renderStopCodePrecedentAndSubsequentTextForm(form) {
        if(!form.showStopCode) {
            return null;
        }

        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Texto Precedente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodePrecendentText}
                    onChange={(e) => this.onChangeValue(e, "stopCodePrecendentText")} />

                <ControlLabel className="margin-top-15">Texto Subsequente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodeSubsequentText}
                    onChange={(e) => this.onChangeValue(e, "stopCodeSubsequentText")} />
            </FormGroup>
        );
    }

    renderNoteColorSwatch(entry, fieldName, label) {
        const isUseLineColor = entry && entry.bgColor === "useLineColor";

        const bgStyle = isUseLineColor ? {} : (() => {
            const [r, g, b, a] = (entry.bgColor || "").split(";").map(Number);
            return { backgroundColor: `rgba(${r}, ${g}, ${b}, ${a})` };
        })();

        return (
            <div key={fieldName} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                <span
                    className={isUseLineColor ? "span-use-line-color" : "span-colors"}
                    style={{
                        width: 35,
                        height: 35,
                        borderRadius: 4,
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...bgStyle
                    }}
                    onClick={() => this.onEditNoteExceptionColor(entry, fieldName)}
                >
                    {isUseLineColor ? 'L' : null}
                </span>
                <small style={{ fontSize: 10, color: '#666' }}>{label}</small>
            </div>
        );
    }

    renderColorSwatch(entry, label) {
        const isUseLineColor = entry && entry.bgColor === "useLineColor";

        const bgStyle = isUseLineColor ? {} : (() => {
            const [r, g, b, a] = (entry.bgColor || "").split(";").map(Number);
            return { backgroundColor: `rgba(${r}, ${g}, ${b}, ${a})` };
        })();

        return (
            <div key={label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                <span
                    className={isUseLineColor ? "span-use-line-color" : "span-colors"}
                    style={{
                        width: 35,
                        height: 35,
                        borderRadius: 4,
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...bgStyle
                    }}
                    onClick={() => this.onEditExceptionColor(entry)}
                >
                    {isUseLineColor ? 'L' : null}
                </span>
                <small style={{ fontSize: 10, color: '#666' }}>{label}</small>
            </div>
        );
    }

    render() {
        const { form, exceptionColorFormTitle, showExceptionColorForm, exceptionColorSelected } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={form.displayType === "BY_COLOR" ? 6 : 12}>
                            <b>Como apresentar as Exceções</b>
                            <FormGroup>
                                <Radio
                                    name="exceptionsFormat"
                                    checked={"PER_LINE" === form.displayType}
                                    onChange={() => this.onChangeRadioValue("PER_LINE", "displayType")} >
                                    Por Linha
                                </Radio>
                                <Radio
                                    name="exceptionsFormat"
                                    checked={"SPLIT_BY_SPACE" === form.displayType}
                                    onChange={() => this.onChangeRadioValue("SPLIT_BY_SPACE", "displayType")} >
                                    Separadas por um espaço - " "
                                </Radio>
                                <Radio
                                    name="exceptionsFormat"
                                    checked={"SPLIT_BY_PIPE" === form.displayType}
                                    onChange={() => this.onChangeRadioValue("SPLIT_BY_PIPE", "displayType")} >
                                    Separadas por uma barra - "|"
                                </Radio>
                                <Radio
                                    name="exceptionsFormat"
                                    checked={"BY_COLOR" === form.displayType}
                                    onChange={() => this.onChangeRadioValue("BY_COLOR", "displayType")} >
                                    Por Cor
                                </Radio>
                            </FormGroup>

                            {this.renderStopTextConfigurationsForm(form)}
                        </Col>

                        {form.displayType === "BY_COLOR" && (
                            <Col sm={6}>
                                <div>
                                    <Alert bsStyle="info" className="margin-bottom-30">
                                        <span className="glyphicon glyphicon-info-sign" style={{ marginRight: 8 }} />
                                        Cada cor está associada à prioridade de percurso correspondente (Prioridade 1: Cor 1, Prioridade 2: Cor 2, etc.)
                                    </Alert>
                                    <div>
                                        <b>Configuração de cores</b>
                                        <div className="margin-top-15">
                                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                {form.exceptionColors.slice(0, 5).map((entry, idx) =>
                                                    this.renderColorSwatch(entry, idx + 1)
                                                )}
                                            </div>
                                            <div style={{ display: 'flex', gap: '10px', marginTop: 10 }}>
                                                {form.exceptionColors.slice(5, 10).map((entry, idx) =>
                                                    this.renderColorSwatch(entry, idx + 6)
                                                )}
                                                <ButtonToolbar>
                                                    <TableButton marginRight icon="icon-undo" title="Reverter" onClick={() => this.onUndoColorSelections()}/>
                                                </ButtonToolbar>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="margin-top-15">
                                        <ControlLabel style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}
                                            onClick={() => this.onToggleUseCustomColorForNotes()}>
                                            <input
                                                type="checkbox"
                                                checked={form.useCustomColorsForNotes}
                                                onChange={() => this.onToggleUseCustomColorForNotes()}
                                                style={{ margin: 0 }}
                                            />
                                            Usar cores personalizadas para notas
                                        </ControlLabel>
                                        <b>Cores para Notas</b>
                                        <div style={{ opacity: !form.useCustomColorsForNotes ? 0.5 : 1, pointerEvents: !form.useCustomColorsForNotes ? 'none' : 'auto',
                                            display: 'flex', gap: '10px', marginTop: 10 }}>
                                            {this.renderNoteColorSwatch(form.tripNoteExceptionColor, 'tripNoteExceptionColor', 'Nota de Viagem')}
                                            {this.renderNoteColorSwatch(form.pathNoteExceptionColor, 'pathNoteExceptionColor', 'Nota de Percurso')}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onSelectData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <ExceptionsColorForm title={exceptionColorFormTitle} show={showExceptionColorForm} onSave={(a) => this.onSaveExceptionColor(a)} exceptionColor={exceptionColorSelected} onHide={() => this.setState({ showExceptionColorForm: false })} />
            </div>
        );
    }
}
